import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: string | null | undefined): string {
    if (value == null || value === '') return '';
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, value);
    return sanitized ?? '';
  }
}